// Utility function to replace multiple placeholders in a string
const replacePlaceholders = (
    template: string | undefined,
    placeholders: Record<string, string | number>,
): string => {
    if (template === undefined) return "";

    return template.replace(/{(.*?)}/g, (_, key) => {
        const value = placeholders[key];
        return value !== undefined ? String(value) : `{${key}}`;
    });
};

export default replacePlaceholders;
